import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import get from 'lodash/get'
import moment from '../../lib/moment.js'
import { Input, Button } from 'reactstrap'
import CreateSubcontractCost from './create-subcontract-cost'
import SearchIcon from "../../static/images/search_icon.svg"
import { FONTS, COLORS } from '../../constants'

export const SearchBar = class extends React.Component {
  state={
    tempSearch: '',
    showCreate: false,
  }

  clickCreate = () => {
    if (get(this.props, 'isEdit')) {
      get(this.props, 'handleClose')()
    } else {
      get(this.props, 'closeSpan')()
      this.setState({
        showCreate: !this.state.showCreate,
        user: '',
        cost: 0,
        price: 0,
        start_date: moment(),
        end_date: moment(),
      })
    }
  }

  createSubcontractCost = () => {
    const payload = {}
    payload.user_id = get(this.state.user, 'value', '')
    payload.cost = this.state.cost
    payload.price = this.state.price
    payload.start_date = this.state.start_date
    payload.end_date = this.state.end_date
    get(this.props, 'createSubcontractCost')(payload)
    this.setState({ showCreate: !this.state.showCreate })
  }

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  render() {
    return (
      <Wrapper>
        <CreateSubcontractCost
          open={ this.state.showCreate }
          toggle={ () => this.setState({ showCreate: !this.state.showCreate }) }
          createSubcontractCost={ this.createSubcontractCost }
          handleInput={ this.handleInput }
          handleSubcontract={ (e) => this.setState({ user: e }) }
          handleStartDate={ (e) => this.setState({ start_date: e }) }
          handleEndDate={ (e) => this.setState({ end_date: e }) }
          user={ this.state.user }
          cost={ this.state.cost }
          price={ this.state.price }
          start_date={ this.state.start_date }
          end_date={ this.state.end_date }
          subcontracts={ get(this.props, 'subcontracts') }
        />
        <SearchField
          placeholder='Search for subcontract'
          onChange={ (e) => {
            if (e.target.value === '') this.props.handleSearch('')
            this.setState({ tempSearch: e.target.value })
          } }
          onKeyDown={ (e) => {
            if (e.keyCode === 13) this.props.handleSearch(this.state.tempSearch)
          } }
        />
        <WrapperButton>
          <CustomButton
            bg={ COLORS.SECONDARY_RED }
            border={ COLORS.PRIMARY_RED_BORDER }
            onClick={ () => this.clickCreate() }
          >Create</CustomButton>
          <CustomButton
            bg={ COLORS.UPLOAD_COLOR }
            border={ COLORS.UPLOAD_COLOR_BORDER }
            onClick={ () => this.props.exportSubcontractCost() }
          >Export</CustomButton>
        </WrapperButton>
      </Wrapper>
    )
  }
}

SearchBar.propTypes = {
  handleSearch: PropTypes.func,
  exportSubcontractCost: PropTypes.func,
}
SearchBar.defaultProps = {
  handleSearch: () => {},
  exportSubcontractCost: () => {},
}

const WrapperButton = styled.div`
  display: flex;
`
const Wrapper = styled.div`
  background-color: #ffffff ;
  margin-bottom: 5px;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 1;
  align-items: center;
  box-shadow: 0px 3px 10px -7px black;
`
const SearchField = styled(Input)`
  height: 30px;
  width: 300px;
  padding-left: 30px;
  background: url(${SearchIcon}) no-repeat scroll 3%;
  background-size: 15px 15px;
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-left: 1%;
  margin-right: 1%;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  ::placeholder {
    color: #CCCCCC;
    font-size: 12px;
  }
`
const CustomButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  background-color: ${props => { return props.bg }};
  width: 100px;
  height: 30px;
  margin-right: 10px;
  margin-top: auto;
  margin-bottom: auto;
  color: white;
  border-color: ${props => props.border};
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background-color: #333333;
    color: #ffffff;
    border-color: #CCCCCC;
    }
`



// WEBPACK FOOTER //
// ./src/components/subcontract-cost/search-bar.js